module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "on_map.3fb88af2.svg";